import axios from "axios";
import configApi from "../config/api";
import globalConfig from "./global";
import Cookies from "js-cookie";

axios.defaults.headers.common["apikey"] = process.env.REACT_APP_APIKEY;

const get = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    let baseUrl = configApi.API_ENDPOINT + url;
    let headers = {
      "Content-Type": `Application/json`,
      Authorization: Cookies.get("token") ? `Bearer ${Cookies.get("token")}` : undefined,
    };
    axios
      .get(baseUrl, data, headers)
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data);
        }
      })
      .catch((error) => {
        if (error.response.data) {
          reject(error.response.data);
        } else {
          reject({ apiError: "Not Found" });
        }
      });
  });
};

const getSignal = (url, signal) => {
  return new Promise((resolve, reject) => {
    let baseUrl = configApi.API_ENDPOINT + url;
    let headers = {
      "Content-Type": "Application/json",
      Authorization: Cookies.get("token") ? `Bearer ${Cookies.get("token")}` : undefined,
    };

    axios({
      method: 'get',
      url: baseUrl,
      headers: headers,
      signal: signal, // Pass the AbortSignal to axios
    })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          reject(error.response.data);
        } else {
          reject({ apiError: "Not Found" });
        }
      });
  });
};

const put = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    let baseUrl = configApi.API_ENDPOINT + url;
    let headers = {
      "Content-Type": "application/json",
      Authorization: Cookies.get("token") ? `Bearer ${Cookies.get("token")}` : undefined,
    };
    axios
      .put(baseUrl, data, { headers: headers })
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          reject(error.response.data);
        } else {
          reject({ apiError: "Not Found" });
        }
      });
  });
};

const post = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    let baseUrl = configApi.API_ENDPOINT + url;
    let headers = {
      "Content-Type": `Application/json`,
      Authorization: Cookies.get("token") ? `Bearer ${Cookies.get("token")}` : undefined,
    };
    console.log("process.env.REACT_APP_APIKEY", process.env.REACT_APP_APIKEY);
    axios
      .post(baseUrl, data, headers)
      .then((res) => {
        if (res.data.status) {
          console.log("response", res.data);
          resolve(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error.response.data);
      });
  });
};

const del = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    let baseUrl = configApi.API_ENDPOINT + url;
    let headers = {
      "Content-Type": `application/json`,
      Authorization: Cookies.get("token") ? `Bearer ${Cookies.get("token")}` : undefined,
    };
    axios
      .delete(baseUrl, data, headers)
      .then((res) => {
        if (res.data.status) {
          resolve(res.data);
        }
      })
      .catch((error) => {
        console.log(error.response);
        reject(error.response.data);
      });
  });
};

const patch = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    let baseUrl = configApi.API_ENDPOINT + url;
    let headers = {
      "Content-Type": `application/json`,
      Authorization: Cookies.get("token") ? `Bearer ${Cookies.get("token")}` : undefined,
    };
    axios
      .patch(baseUrl, data, headers)
      .then((res) => {
        console.log("patch res", res);
        if (res.data.status) {
          resolve(res.data);
        }
      })
      .catch((error) => {
        console.log(error.response);
        reject(error.response.data);
      });
  });
};

const obj = {
  get,
  getSignal,
  post,
  del,
  patch,
  put
};

export default obj;
